/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InspectionDataDto } from '../../models/inspection-data-dto';

export interface InspectionDataControllerFindById$Params {
  id: string;
}

export function inspectionDataControllerFindById(http: HttpClient, rootUrl: string, params: InspectionDataControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<InspectionDataDto>> {
  const rb = new RequestBuilder(rootUrl, inspectionDataControllerFindById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<InspectionDataDto>;
    })
  );
}

inspectionDataControllerFindById.PATH = '/api/inspection-data/{id}';
